import React, { useState } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Bar } from 'react-chartjs-2';
import { shuffle } from 'lodash';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);
import ErrorBoundary from 'components/ErrorBoundary';



const TopTPA = ({data}) => {
  const [active, setActive] = useState('6');
  const chartData = {
    maintainAspectRatio: false,
    labels: data.map(({ name }) => name),
    datasets: [
      {
        label: 'Dispense Fee Revenue',
        data: data.map(({ value }) =>  value),
        borderColor: '#B54DA0',
        backgroundColor: '#B54DA0',
        barPercentage: 0.4,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: {
        display: false,
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true ,
    plugins: {
      tooltip: {
        callbacks: {
          title: function (item) {
            const { count, name } = data[item[0].dataIndex];
            return `${name}\nCaptured Rx Count ${count}`;
          },
          label: function (d,t) {
            var xLabel = d.dataset.label;
            var yLabel ='$' + Number(d.formattedValue.replace(/[^0-9.-]+/g,"")).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
            return xLabel + ': ' + yLabel;
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        display: false,
        align: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'end'
            : 'start';
        },
        color: function (context) {
          return context.dataset.data[context.dataIndex] < 150000
            ? 'black'
            : 'black';
        },
        anchor: 'center',
        padding: {
          right: 2,
        },
        labels: {
          padding: { top: 10 },
          value: {
            color: '#2B3346',
          },
        },
        formatter: function (value) {
          return '$' + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
      },
    },
  };

  const handleActive = (title) => {
    if (active === title) return;
    setActive(title);
    let shuffleArry = shuffle(data);
    setData(shuffleArry);
  };

  const getDate = () => {
    handleActive('custom')
  };

  return (
    <ErrorBoundary>
      <Card className='p-3 h-100'>
        <CardHeader className='border-0 bg-white px-0'>
          <Row className='align-items-center'>
            <Col>
              <CardTitle className='f-20 font-weight-500 mb-0'>
                Top Performing TPAs{' '}
                <p className='dashboard-sub-text'>By Dispense Fee Revenue</p>
              </CardTitle>
            </Col>
            <Col xs='auto'>
              <Nav className='widget-tabs'>
                
              </Nav>
            </Col>
          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
          <div className='dashboard-chart-height'>
            <Bar
              options={options}
              data={chartData}
              plugins={[ChartDataLabels]}
            />
          </div>
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default TopTPA;
